import moment from "packages/moment";

export const formatDateWithoutTimeZone = (value: Date): string => {
  const momentDate = moment(value);
  return momentDate.format("DD-MM-YYYY HH:mm");
};
